// Global notification service
// Used by API interceptors and other modules that can't access React context directly

let globalNotificationHandlers = {
    showError: (message) => console.error(message),
    showSuccess: (message) => console.log(message),
};

export const setNotificationHandlers = (handlers) => {
    globalNotificationHandlers = { ...globalNotificationHandlers, ...handlers };
};

export const getNotificationHandlers = () => globalNotificationHandlers;

export const notificationService = {
    showError: (message) => globalNotificationHandlers.showError(message),
    showSuccess: (message) => globalNotificationHandlers.showSuccess(message),
};
